import { render, staticRenderFns } from "./FooterApp.vue?vue&type=template&id=212fdbad&scoped=true&lang=pug&"
import script from "./FooterApp.vue?vue&type=script&lang=ts&"
export * from "./FooterApp.vue?vue&type=script&lang=ts&"
import style0 from "./FooterApp.vue?vue&type=style&index=0&id=212fdbad&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212fdbad",
  null
  
)

export default component.exports